<template>
  <v-flex d-flex align-center style="padding: 0 4px">
    <v-progress-linear
      color="white"
      :background-color="color"
      :value="100 - (statisticsA || 0) * 100 / buffer"
      :height="height"
      style="width: 40%; margin: 10px 0"
    ></v-progress-linear>

    <strong v-if="name === 'points'" style="width: 5%">
      {{ statisticsA || 0 }}
    </strong>
    <span v-else style="width: 5%">
      {{ statisticsA || 0 }}
    </span>

    <strong v-if="primary" style="width: 12%">
      {{ name.toUpperCase() }}
    </strong>
    <small v-else style="width: 12%">
      {{ name.toUpperCase() }}
    </small>

    <strong v-if="name === 'points'" style="width: 5%">
      {{ statisticsB || 0 }}
    </strong>
    <span v-else style="width: 5%">
      {{ statisticsB || 0 }}
    </span>

    <v-progress-linear
      :color="color"
      background-color="white"
      :value="(statisticsB || 0) * 100 / buffer"
      :height="height"
      style="width: 40%; margin: 10px 0"
    ></v-progress-linear>
  </v-flex>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    name: {},
    buffer: {},
    color: {},
    statisticsA: {},
    statisticsB: {},
    height: {
      default: 7,
    },
    primary: {
      type: Boolean,
      default: false,
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/components/MatchLive/StatisticsByTeam/Row.vue